<template>
  <div class="app-agreement">
    <div class="content">
      <!-- <p><b>全民推广员帮助规则：</b></p> -->
      <b>1、如何推广赚返现？</b>
      <p>用户推荐好友注册开店，并完成付费即可获得 “50元”返现，如你的好友再次推广他人，并完成开店支付，你还可获得 15元 的返现。</p>
      <b>2、如何进行推广？</b>
      <p>你点击活动页面左下角的“推荐开店”，分享“推广页面”给微信好友，或朋友圈即可。用户也可以点击页面下方“扫码邀请”生成邀请二维码，“面对面”扫码开店。</p>
      <b>3、如何实现推广利益最大化？</b>
      <p>用户点击活动页面右下角的“招募推广员”，分享更多的好友，帮你去推广。</p>
      <b>4、如何查看赚钱进度？</b>
      <p>用户可在活动页面，查看返现金额，也可以点击页面“钱包余额”，查看明细，并进行提现。如您是小店店主，也可通过管理端-店铺-赚钱红包，查看返现金额及相应明细。</p>
    </div>
  </div>

</template>

<style lang="less">
.app-agreement {
  min-height: 100vh;
  font-size: 1.4rem;
  white-space: normal;
  .content {
    width: 98%;
    margin: 0 auto;
  }
}
</style>